// Smart REC Accordion Widget

class WidgetHandlerClass extends elementorModules.frontend.handlers.Base {

    getDefaultSettings() {
        return {
            selectors: {
                showMoreButton: '#showMoreButton',
                showMoreText: '#showMoreText'
            }
        }
    }
    
    getDefaultElements() {
        const selectors = this.getSettings( 'selectors' );

        return {
            $showMoreButton: this.$element.find( selectors.showMoreButton ),
            $showMoreText: this.$element.find( selectors.showMoreText )
        }
    }
    
    showMoreTextClick( event ) {
        event.preventDefault();
        this.elements.$showMoreText[0].classList.toggle('show');
    }

    bindEvents() {
        this.elements.$showMoreButton.on( 'click', this.showMoreTextClick.bind(this) );
    }
}


jQuery(window).on( 'elementor/frontend/init', () => {
    const addHandler = ( $element ) => {
        elementorFrontend.elementsHandler.addHandler( WidgetHandlerClass, { $element });
    };
 
    elementorFrontend.hooks.addAction( 'frontend/element_ready/show_more.default', addHandler );
 } );

 